import React, { Suspense, lazy } from 'react';
import { HeroSection } from '../components/sections/HeroSection';
// Everything below hero is lazy-loaded
const ProblemSection = lazy(() => import('../components/sections/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const SolutionSection = lazy(() => import('../components/sections/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const BenefitsSection = lazy(() => import('../components/sections/BenefitsSection').then(m => ({
  default: m.BenefitsSection
})));
const BonusSection = lazy(() => import('../components/sections/BonusSection').then(m => ({
  default: m.BonusSection
})));
const ScarcitySection = lazy(() => import('../components/sections/ScarcitySection').then(m => ({
  default: m.ScarcitySection
})));
const PricingSection = lazy(() => import('../components/sections/PricingSection').then(m => ({
  default: m.PricingSection
})));
const TestimonialSection = lazy(() => import('../components/sections/TestimonialSection').then(m => ({
  default: m.TestimonialSection
})));
const GuaranteeSection = lazy(() => import('../components/sections/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FAQSection = lazy(() => import('../components/sections/FAQSection').then(m => ({
  default: m.FAQSection
})));
const ClosingSection = lazy(() => import('../components/sections/ClosingSection').then(m => ({
  default: m.ClosingSection
})));
const FooterSection = lazy(() => import('../components/sections/FooterSection').then(m => ({
  default: m.FooterSection
})));
const SocialProofPopup = lazy(() => import('../components/ui/SocialProofPopup').then(m => ({
  default: m.SocialProofPopup
})));
export function LandingPage() {
  return <main className="min-h-screen bg-background-dark text-gray-300 font-body selection:bg-primary/30 selection:text-white" data-id="element-472">
      <HeroSection data-id="element-473" />
      <Suspense fallback={null} data-id="element-474">
        <ProblemSection data-id="element-475" />
        <SolutionSection data-id="element-476" />
        <BenefitsSection data-id="element-477" />
        <BonusSection data-id="element-478" />
        <ScarcitySection data-id="element-479" />
        <PricingSection data-id="element-480" />
        <TestimonialSection data-id="element-481" />
        <GuaranteeSection data-id="element-482" />
        <FAQSection data-id="element-483" />
        <ClosingSection data-id="element-484" />
        <FooterSection data-id="element-485" />
        <SocialProofPopup data-id="element-486" />
      </Suspense>
    </main>;
}